module.exports = __webpack_public_path__ + "img/thigh.98a9a392.png";